<template lang="pug">
el-form-item(prop="name", :rules="nameRequiredRule")
  template(#label) 唯一名称
    el-tooltip(effect="light", content="修改名称后需按回车确认")
      i.el-icon-info
  template(v-if="showInput")
    el-input(type="text", v-model="optionModel.name", :readonly="widgetNameReadonly", @change="updateWidgetNameAndRef")
  //-  关联子表单
  template(v-else)
    el-select(v-model="optionModel.name", allow-create, filterable, :disabled="widgetNameReadonly", @change="updateWidgetNameAndRef", :title="optionModel.name")
      el-option(v-for="(sf, sfIdx) in dynamicFieldList", :key="sf.name", :label="sf.label", :value="sf.name")
</template>
<script>
import { VFormSDK } from "@/CommonDP/lib/vform/VFormDesigner.umd.min.js";
const { i18n } = VFormSDK;

import { subFormBus } from "./subFormBus.js";
function isEmptyStr(str) {
  return str === undefined || (!str && str !== 0 && str !== "0") || !/[^\s]/.test(str);
}
export default {
  mixins: [i18n],
  inject: ["serverFieldList", "getDesignerConfig", "subformFieldList", "isSubFormChildWidget"],
  inheritAttrs: false,
  props: {
    designer: { default: () => ({}), type: Object },
    optionModel: { default: () => ({}), type: Object },
    selectedWidget: { default: () => ({}), type: Object }
  },
  data() {
    return {
      nameRequiredRule: [{ required: true, message: "name required" }]
    };
  },
  computed: {
    dynamicFieldList() {
      return this.isSubformJyht ? this.subformList : this.serverFieldList.map((item) => ({ ...item, label: `${item.label}(${item.name})`, rawLabel: item.label }));
    },
    showInput() {
      return (!!this.selectedWidget.category && ["custom-sub-form", "sub-form", "jyht-table"].indexOf(this.selectedWidget.type) === -1) || this.noFieldList;
    },
    isSubformJyht() {
      return subFormBus.isSubformJyht;
    },
    widgetNameReadonly() {
      return !!this.getDesignerConfig().widgetNameReadonly;
    },
    noFieldList() {
      return !this.serverFieldList || this.serverFieldList.length <= 0;
    },
    fieldList() {
      return this.isSubFormChildWidget() ? this.subformFieldList() : this.serverFieldList;
    },
    subformList() {
      return subFormBus.list;
    }
  },
  created() {
    subFormBus.bindDesigner(this);
  },
  methods: {
    updateWidgetNameAndRef(newName) {
      const oldName = this.designer.selectedWidgetName;
      if (isEmptyStr(newName)) {
        this.selectedWidget.options.name = oldName;
        this.$message.info(this.i18nt("designer.hint.nameRequired"));
        return;
      }
      if (this.designer.formWidget) {
        const foundRef = this.designer.formWidget.getWidgetRef(newName);
        // 校验是否已经有对应名称组件
        if (foundRef) {
          this.selectedWidget.options.name = oldName;
          this.$message.info(this.i18nt("designer.hint.duplicateName") + newName);
        } else {
          const widgetInDesign = this.designer.formWidget.getWidgetRef(oldName);
          if (!!widgetInDesign && !!widgetInDesign.registerToRefList) {
            widgetInDesign.registerToRefList(oldName); // 注册组件新的ref名称并删除老的ref！！
            const newLabel = this.getLabelByFieldName(newName);
            this.designer.updateSelectedWidgetNameAndLabel(this.selectedWidget, newName, newLabel);
          }
        }
      }
    },
    getLabelByFieldName(fieldName) {
      const list = this.dynamicFieldList;
      const item = list.find(({ name }) => name === fieldName) || {};
      return item.rawLabel;
    }
  }
};
</script>
